import { gql, useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import { useContext, useEffect, useRef } from "react";

import { MessageManager } from "context";
import {
  LICENSE_ERROR_EVENT,
  LICENSE_ERROR_MESSAGE,
  createLicenseNotificationGate,
} from "services/licenseNotifications";

const LICENSE_STATUS = gql`
  query licenseStatus {
    licenseStatus {
      effectiveStatus
      expiresAt
      severity
      mode
      project {
        id
        name
      }
    }
  }
`;

function AdminLicenseMonitor({ isAdministrator }) {
  const { handleSnackbar } = useContext(MessageManager);
  const gate = useRef(createLicenseNotificationGate());
  const { data } = useQuery(LICENSE_STATUS, {
    skip: !isAdministrator,
    pollInterval: 60000,
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (!isAdministrator) {
      gate.current.reset();
      return undefined;
    }

    const handleLicenseError = (event) => {
      if (gate.current.processErrorCode(event.detail?.code)) {
        handleSnackbar(LICENSE_ERROR_MESSAGE, "error");
      }
    };

    window.addEventListener(LICENSE_ERROR_EVENT, handleLicenseError);
    return () => window.removeEventListener(LICENSE_ERROR_EVENT, handleLicenseError);
  }, [handleSnackbar, isAdministrator]);

  useEffect(() => {
    if (
      isAdministrator &&
      gate.current.processStatus(data?.licenseStatus)
    ) {
      handleSnackbar(LICENSE_ERROR_MESSAGE, "error");
    }
  }, [data?.licenseStatus, handleSnackbar, isAdministrator]);

  return null;
}

AdminLicenseMonitor.propTypes = {
  isAdministrator: PropTypes.bool.isRequired,
};

export default AdminLicenseMonitor;
